import { Box } from "@mui/material";

const NoteIndicatorLine = (props: { hasFocus: boolean}) => (
    <Box sx={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: '-40px',
        marginLeft: '-1px',
        borderLeft: (theme) => `3px solid ${props.hasFocus 
            ? theme.palette.primary.main 
            : theme.palette.divider}`
    }}/>
);

export default NoteIndicatorLine;